"use client"
import S3Image from "@/components/S3Image";
import { useSite } from "@/lib/hooks/site";
import { useEffect, useState } from "react";
import localImageLoader from "@/lib/local-image-loader";
import SmileWomanMobile from "../../../../../public/SmileWomanMobile.webp";
import { useTranslation } from "@/hooks/translationContext";

export default function BulkOfferMobileImage() {
  const site = useSite();
  const [quoteImage, setQuoteImage] = useState("");
  const {t} = useTranslation();

  useEffect(() => {
    const calltoaction = site?.setting?.design?.calltoaction;
    if (calltoaction?.["general-quote"]) {
      const url = `site/${site.id}/assets/${calltoaction["general-quote"]}`;
      setQuoteImage(url);
    }
  }, [site]);

  return (
    <S3Image
      sizes="185px"
      loading="lazy"
      loader={!quoteImage ? localImageLoader : undefined}
      src={quoteImage || SmileWomanMobile}
      alt={`${t("venue-offer-image-alt")} ~ ${site.descriptions[0]?.title}`}
      title={`${t("venue-offer-image-alt")} ~ ${site.descriptions[0]?.title}`}
      width={185}
      height={194}
      className="absolute -left-[53px] top-[-39.29px] w-[185px] h-[194px]"
    />
  )
}
